/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_ShortformInputs */



/**
* | output |
* | --- |
* | "Delete shortform" |
*
* @param {Delete_ShortformInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_shortform = /** @type {((inputs?: Delete_ShortformInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_ShortformInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer l'abréviation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kurzform löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina abbreviazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить краткую форму")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar formato corto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除缩写")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショートフォームを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संक्षिप्त रूप हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir forma abreviada")
	return /** @type {LocalizedString} */ ("Delete shortform")
});